import { addDays } from 'date-fns/fp'

const DEFAULT_STORAGE_PREFIX = '7f_'

/**
 * Cookie-based storage for URL state persistence
 */
export const cookieStorage = {
  get: (key: string | number | symbol) => {
    if (typeof window === 'undefined') return null

    const storageKey = getStorageKey(key)
    const cookies = document.cookie.split(';')

    for (const cookie of cookies) {
      const [cookieKey, cookieValue] = cookie.trim().split('=')
      if (cookieKey === storageKey) {
        return decodeURIComponent(cookieValue)
      }
    }

    return null
  },

  set: (key: string | number | symbol, value: string) => {
    if (typeof window === 'undefined') return

    const storageKey = getStorageKey(key)
    const expires = addDays(5)(new Date())
    document.cookie = `${storageKey}=${encodeURIComponent(value)}; ${cookieAttributes(expires.toUTCString())}`
  },

  remove: (key: string | number | symbol) => {
    if (typeof window === 'undefined') return

    const storageKey = getStorageKey(key)
    document.cookie = `${storageKey}=; ${cookieAttributes('Thu, 01 Jan 1970 00:00:00 UTC')}`
  },
}

const cookieAttributes = (expires: string) => {
  const secure = window.location.protocol === 'https:' ? '; Secure' : ''
  return `expires=${expires}; path=/; SameSite=Lax${secure}`
}

const getStorageKey = (
  key: string | number | symbol,
  storagePrefix: string = DEFAULT_STORAGE_PREFIX
) => `${storagePrefix}${String(key)}`
